import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody
} from "../../APIHelpers/Responses";

export const categoryServices = {
  addNewDiscoveryCategory,
  updatedDiscoveryCategory,
  softDeleteRestoreDiscoveryCategory,
  deleteDiscoveryCategory,
  getDiscoveryCategoryList,
};

// Add New Category
async function addNewDiscoveryCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewDiscoveryCategory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Category
async function updatedDiscoveryCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedDiscoveryCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Soft Delete & Restore Category
async function softDeleteRestoreDiscoveryCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreDiscoveryCategory`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  if(!userData?.bookmarkType){
    handleResponse(data)
  }
  return data;
}

// Delete Category
async function deleteDiscoveryCategory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteDiscoveryCategory`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Get All Category
async function getDiscoveryCategoryList(status, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getDiscoveryCategoryList/${status}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getDiscoveryCategoryList/${status}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}